module.exports = __webpack_public_path__ + "static/img-41.1d98689e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img-41.jpg
// module id = 467
// module chunks = 75205924225882